import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Header from '../../components/ui/Header';
import V5Footer from '../../components/V5Footer';

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>About · Praesidio Care</title>
        <meta
          name="description"
          content="Praesidio Care is a product studio in San Francisco and New York. The same team ships ByOnco, SurakshaPath, Parkingkar, and Vayu AI Glasses."
        />
        <link rel="canonical" href="https://www.praesidiocare.com/about-us" />
      </Helmet>
      <Header />
      <main className="w-site">
        <div className="w-wrap">
          <header className="w-page-hero">
            <p className="w-kicker">About the lab</p>
            <h1>The company behind the products.</h1>
          </header>

          <section className="w-section w-prose">
            <p className="w-kicker">Who</p>
            <div>
              <p>
                Praesidio Care builds ByOnco, SurakshaPath, Parkingkar, and Vayu AI Glasses,
                and a small number of outside products at a fixed price.
              </p>
              <p>
                The lab is in San Francisco and New York. This site is for partners
                who want that team on a product.
              </p>
              <p>
                We take a small number of outside builds. The price is fixed after
                a written scope. The source ends up in your name.
              </p>
            </div>
          </section>

          <section className="w-section">
            <div className="w-head">
              <p className="w-kicker">What we will say in a meeting</p>
              <h2>Four things, then the work.</h2>
            </div>
            <ol className="w-steps">
              <li>
                <strong>01 The environment comes first</strong>
                <p>A hospital corridor, a festival street, a phone on a weak network. If it only works on office wifi, it is not finished.</p>
              </li>
              <li>
                <strong>02 The model can be wrong</strong>
                <p>Super Intelligence on this team is narrow on purpose. A model anyone can prompt is not a system. When a confident wrong answer would hurt someone, it fails closed.</p>
              </li>
              <li>
                <strong>03 You should be able to leave</strong>
                <p>Code, accounts, and a walkthrough. A retainer exists only if you want one after launch.</p>
              </li>
              <li>
                <strong>04 We answer with a number</strong>
                <p>A brief gets a scope and a price. If the work is not ours, the reply says that.</p>
              </li>
            </ol>
          </section>

          <section className="w-section">
            <div className="w-head">
              <p className="w-kicker">The systems</p>
              <h2>Open them. That is the introduction.</h2>
            </div>
            <div className="w-work-grid">
              {[
                ['https://www.getbyonco.com/', 'ByOnco', 'Oncology', '/images/portfolio/byonco.webp'],
                ['/products/surakshapath', 'SurakshaPath', 'Public safety', '/images/portfolio/surakshapath.webp'],
                ['/products/parkingkar', 'Parkingkar', 'Mobility', '/images/portfolio/parkingkar.webp'],
                ['https://www.vayuglasses.in/', 'Vayu AI Glasses', 'Super Intelligence', '/images/portfolio/vayu-x.webp'],
              ].map(([href, name, field, image]) => (
                href.startsWith('http') ? (
                <a className="w-work" href={href} key={href} target="_blank" rel="noopener noreferrer">
                  <span className="w-field">{field}</span>
                  <figure className="w-shot">
                    <img src={image} alt="" />
                  </figure>
                  <h3>{name}</h3>
                </a>
                ) : (
                <Link className="w-work" to={href} key={href}>
                  <span className="w-field">{field}</span>
                  <figure className="w-shot">
                    <img src={image} alt="" />
                  </figure>
                  <h3>{name}</h3>
                </Link>
                )
              ))}
            </div>
          </section>

          <section className="w-section" aria-labelledby="about-reading">
            <div className="w-head">
              <p className="w-kicker">Further reading</p>
              <h2 id="about-reading">The company, and the intelligence.</h2>
            </div>
            <div className="w-list">
              <Link to="/company/praesidio-care-private-limited">
                <span>01</span>
                <h3>Praesidio Care Private Limited</h3>
                <p>The company on the register, the GSTIN, and the two doors into the work.</p>
              </Link>
              <Link to="/super-intelligence">
                <span>02</span>
                <h3>Super Intelligence</h3>
                <p>What we mean by a system that reasons, and that a person can check.</p>
              </Link>
              <Link to="/company/global-presence">
                <span>03</span>
                <h3>Studios</h3>
                <p>San Francisco, New York, Bengaluru, and Nashik.</p>
              </Link>
            </div>
          </section>

          <section className="w-close">
            <div>
              <h2>If you have a brief, send it.</h2>
              <p>San Francisco and New York. We reply with a scope and a number.</p>
            </div>
            <div className="w-actions">
              <Link className="w-btn" to="/contact">Start a brief</Link>
              <a className="w-btn w-btn-ghost" href="/in">India studio</a>
            </div>
          </section>
        </div>
      </main>
      <V5Footer />
    </>
  );
};

export default AboutUs;
